import React from 'react';
import { useAllhomesContext } from './hook';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesGlobalContextConsumer = _ref => {
  var _ref$requestedValues = _ref.requestedValues,
    requestedValues = _ref$requestedValues === void 0 ? [] : _ref$requestedValues,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? () => ___EmotionJSX(React.Fragment, null) : _ref$children;
  var context = useAllhomesContext(...(Array.isArray(requestedValues) ? requestedValues : [requestedValues]));
  return children(context);
};